import LogisticsCompany from "@/enum/LogisticsCompany";
import LogisticsCompanyType from "@/enum/LogisticsCompanyType";

const LogisticsCompanyTypeMap = {
    [LogisticsCompany.ZTO]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ZTO56]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.YTO]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.STO]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.YUNDA]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.YUNDA56]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ANE66]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ANE56]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.JD_EXPRESS]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.JD_HPCP]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.GTO]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.EMS]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.EYB]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.SF]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.KUAYUE]: LogisticsCompanyType.DIRECT_AND_FRANCHISE_MIXED,
    [LogisticsCompany.EXFRESH]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.DBL]: LogisticsCompanyType.DIRECT_AND_FRANCHISE_MIXED,
    [LogisticsCompany.DBKD]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.JIUYESCM]: LogisticsCompanyType.DIRECT_AND_FRANCHISE_MIXED,
    [LogisticsCompany.ZJS]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.POST]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.POSTB]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.POSTS]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.HTKY]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.BESTQJT]: LogisticsCompanyType.DIRECT_AND_FRANCHISE_MIXED,
    [LogisticsCompany.BEST]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.UC]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.WXWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.QFKD]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.LB]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.UAPEX]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.FAST]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.HOAU]: LogisticsCompanyType.DIRECT_AND_FRANCHISE_MIXED,
    [LogisticsCompany.PJBEST]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.RFD]: LogisticsCompanyType.DIRECT_AND_FRANCHISE_MIXED,
    [LogisticsCompany.YCKY]: LogisticsCompanyType.DIRECT_AND_FRANCHISE_MIXED,
    [LogisticsCompany.YMDD]: LogisticsCompanyType.DIRECT_AND_FRANCHISE_MIXED,
    [LogisticsCompany.SURE]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.SUT56]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.CRE]: LogisticsCompanyType.DIRECT_AND_FRANCHISE_MIXED,
    [LogisticsCompany.AIR]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.CNEX]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.FEDEX]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.QRT]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.JYMWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.XFWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.DTW]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.DSWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.CNDTK]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.YTWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.CYWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.XBWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.LWT]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.SNWL]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.NDSD]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.BHWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.FW]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.CF]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.YC]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.DFH]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.FYPS]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.HMZJB]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ESB]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.HQWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.AXWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.TOPSPEED]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.HUAQIEX]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.DN]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.DSJZ]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.KHWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.SXJD]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.JT]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.SZKKE]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ZY]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.JDKY]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.YUNDA_DTD]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.BSYP]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.WTO]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.WOWVIP]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.TTWLKD]: LogisticsCompanyType.NEITHER_DIRECT_NOR_FRANCHISE,
    [LogisticsCompany.STE56]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.SFKY]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.ANDE]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.BESTGJ]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.DANGDANG]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.EWE]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.FYP]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.GJWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.HYWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.KXTX]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.RRS]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.STO56]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.STOGJ]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.WSKD]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.WSPY]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.XLOBO]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.YUNDAGJ]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ZTOGJ]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ZYEHQ]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ZYSF]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ZZSY]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.YUNDA_TC]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.FENGWANG]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.GGSJJJ]: LogisticsCompanyType.NEITHER_DIRECT_NOR_FRANCHISE,
    [LogisticsCompany.KDLL]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.PADTF]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.TTWLDD]: LogisticsCompanyType.NEITHER_DIRECT_NOR_FRANCHISE,
    [LogisticsCompany.NZSY]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ZTOCC]: LogisticsCompanyType.DIRECT_AND_FRANCHISE_MIXED,
    [LogisticsCompany.ALIHY]: LogisticsCompanyType.NEITHER_DIRECT_NOR_FRANCHISE,
    [LogisticsCompany.ALIWL]: LogisticsCompanyType.NEITHER_DIRECT_NOR_FRANCHISE,
    [LogisticsCompany.ALIWLDD]: LogisticsCompanyType.NEITHER_DIRECT_NOR_FRANCHISE,
    [LogisticsCompany.TTSX]: LogisticsCompanyType.NEITHER_DIRECT_NOR_FRANCHISE,
    [LogisticsCompany.JD_SELLER_DELIVERY]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.HXWL]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.TJS]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.DBKY]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.DOUYIN_EXPRESS]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.RYWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.SANZHI56]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.OTHER]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.JYMKD]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.FJZYWL]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.YADEX]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.ZTZHWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.TZKY]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.SCZB]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.TNJEX]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.CNDJ]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.JSD]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.JAX]: LogisticsCompanyType.DIRECT,
    [LogisticsCompany.HSYSD]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.BNSY]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.RHWL]: LogisticsCompanyType.FRANCHISE,
    [LogisticsCompany.LUCKYFASTEX]: LogisticsCompanyType.DIRECT,
};

export default LogisticsCompanyTypeMap;
